module.exports = __webpack_public_path__ + "static/logo-302e1a05abff76dea701f89395aea01e.png";